angular.module("impactx.comments").service('CommentOnSaveService', CommentOnSaveService);

CommentOnSaveService.inject = ['$mdDialog'];

function CommentOnSaveService($mdDialog)
{
    return {
        showCommentOnSaveDialog: function(callBackFunction, event, warningLabel, saveLabel, abortLabel, commentLabel, commentData)
        {
            $mdDialog.show({
                controller: "CommentOnSaveCtrl",
                controllerAs: "commentOnSaveCtrl",
                templateUrl: "shared/comments/templates/commentonsave.tmpl.html",
                parent: angular.element(document.body),
                targetEvent: event,
                clickOutsideToClose: false,
                locals: {
                    warning: warningLabel,
                    saveLabel: saveLabel,
                    abortLabel: abortLabel,
                    commentLabel: commentLabel,
                    commentDTO: commentData
                }
            })
            .then(function()
            {
                callBackFunction();
            }, function() {});
        }
    };
}